<template>
  <div class="main">
    <header class="panel-heading">
      <h3 class="panel-title">宿舍資訊暨設備教育訓練維護</h3>
    </header>

    <section class="panel panel-default">
      <div class="panel-body" v-if="!isAdmin('stay')">
        <div class="alert alert-danger">只有宿舍管理者可以維護教育訓練。</div>
      </div>

      <div class="panel-body" v-else>
        <div class="row form-group">
          <div class="col-md-4">
            <label>模組標題</label>
            <input v-model="form.title" type="text" class="form-control" />
          </div>
          <div class="col-md-2">
            <label>抽題數</label>
            <input v-model.number="form.drawQuestionCount" type="number" min="1" class="form-control" />
          </div>
          <div class="col-md-2">
            <label>及格題數</label>
            <input v-model.number="form.passQuestionCount" type="number" min="1" class="form-control" />
          </div>
          <div class="col-md-4">
            <label>上架狀態</label>
            <select v-model="form.isPublished" class="form-control">
              <option value="Y">上架</option>
              <option value="N">下架</option>
            </select>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <p class="help-block">抽題數必須小於啟用中的題目數，及格題數不可大於抽題數。</p>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>影片連結</label>
            <input v-model="form.videoUrl" type="text" class="form-control" placeholder="請輸入 YouTube 或其他外部影片連結" />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>模組說明</label>
            <textarea v-model="form.description" rows="4" class="form-control"></textarea>
          </div>
        </div>

        <hr />

        <div class="row form-group">
          <div class="col-md-12 text-right">
            <a href="javascript:;" class="btn btn-default" @click="addQuestion">新增題目</a>
          </div>
        </div>

        <div class="question-card panel panel-default" v-for="(question, index) in form.questions" :key="question.localKey">
          <div class="panel-heading clearfix">
            <div class="pull-left">題目 {{ index + 1 }}</div>
            <div class="pull-right">
              <a href="javascript:;" class="text-danger" @click="removeQuestion(index)">移除</a>
            </div>
          </div>
          <div class="panel-body">
            <div class="row form-group">
              <div class="col-md-6">
                <label>題型</label>
                <select v-model="question.questionType" class="form-control" @change="handleQuestionTypeChange(question)">
                  <option value="trueFalse">是非題</option>
                  <option value="singleChoice">單選題</option>
                  <option value="multipleChoice">多選題</option>
                  <option value="singleLineText">單行文字</option>
                  <option value="multiLineText">多行文字</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>是否啟用</label>
                <select v-model="question.isActive" class="form-control">
                  <option value="Y">啟用</option>
                  <option value="N">停用</option>
                </select>
              </div>
            </div>

            <div class="row form-group">
              <div class="col-md-12">
                <label>題目內容</label>
                <textarea v-model="question.questionText" rows="3" class="form-control"></textarea>
              </div>
            </div>

            <div class="row form-group" v-if="isTextQuestion(question)">
              <div class="col-md-12">
                <label>標準答案</label>
                <textarea v-if="question.questionType === 'multiLineText'" v-model="question.correctAnswerText" rows="3" class="form-control"></textarea>
                <input v-else v-model="question.correctAnswerText" type="text" class="form-control" />
                <p class="help-block">文字題採完全比對評分，會自動忽略前後空白與換行格式差異。</p>
              </div>
            </div>

            <div class="row form-group" v-else>
              <div class="col-md-12">
                <label>選項設定</label>

                <div v-if="question.questionType === 'trueFalse'" class="true-false-editor">
                  <div class="radio-custom radio-inline" v-for="(option, optionIndex) in question.options" :key="option.localKey">
                    <input
                      :id="`${question.localKey}-${option.localKey}`"
                      type="radio"
                      :checked="option.isCorrect === 'Y'"
                      @change="setSingleCorrect(question, optionIndex)"
                    />
                    <label :for="`${question.localKey}-${option.localKey}`">{{ option.optionText }}</label>
                  </div>
                  <div class="help-block">請選擇是非題的正確答案。</div>
                </div>

                <div v-else>
                  <div class="option-row row" v-for="(option, optionIndex) in question.options" :key="option.localKey">
                    <div class="col-md-1 text-center option-check">
                      <input
                        v-if="question.questionType === 'singleChoice'"
                        type="radio"
                        :name="`single-${question.localKey}`"
                        :checked="option.isCorrect === 'Y'"
                        @change="setSingleCorrect(question, optionIndex)"
                      />
                      <input
                        v-else
                        type="checkbox"
                        v-model="option.isCorrectBool"
                        @change="setMultipleCorrect(option)"
                      />
                    </div>
                    <div class="col-md-9">
                      <input v-model="option.optionText" type="text" class="form-control" :placeholder="`選項 ${optionIndex + 1}`" />
                    </div>
                    <div class="col-md-2 text-right">
                      <a href="javascript:;" class="text-danger" @click="removeOption(question, optionIndex)">刪除</a>
                    </div>
                  </div>
                  <a href="javascript:;" class="btn btn-link" @click="addOption(question)">新增選項</a>
                  <div class="help-block" v-if="question.questionType === 'singleChoice'">單選題只能有一個正確答案。</div>
                  <div class="help-block" v-else>多選題需完整選對全部正確答案才得分。</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12 text-center">
            <a href="javascript:;" class="btn btn-default" style="margin-right: 8px;" @click="goBack">返回</a>
            <a href="javascript:;" class="btn btn-primary" @click="saveModule">儲存</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        id: null,
        title: '',
        description: '',
        videoUrl: '',
        drawQuestionCount: 1,
        passQuestionCount: 1,
        isPublished: 'N',
        questions: []
      },
      loading: false
    };
  },
  created() {
    if (!this.isAdmin('stay')) {
      return;
    }
    const storeData = this.getStore(this.$route.name);
    if (storeData) {
      const parsed = JSON.parse(storeData);
      if (parsed.id) {
        this.loadModule(parsed.id);
      }
    }
    if (this.form.questions.length === 0) {
      this.addQuestion();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'stay.training' });
    },
    loadModule(id) {
      this.loading = true;
      this.$axios.get(`/api/DormitoryTraining/module/${id}`).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '載入失敗');
          return;
        }
        const data = resp.data.data;
        this.form.id = data.id;
        this.form.title = data.title;
        this.form.description = data.description || '';
        this.form.videoUrl = data.videoUrl;
        this.form.drawQuestionCount = data.drawQuestionCount;
        this.form.passQuestionCount = data.passQuestionCount;
        this.form.isPublished = data.isPublished;
        this.form.questions = (data.questions || []).map((question, index) => this.hydrateQuestion(question, index));
      }).finally(() => {
        this.loading = false;
      });
    },
    hydrateQuestion(question, index) {
      const hydrated = {
        id: question.id || null,
        localKey: question.id || `question-${Date.now()}-${index}`,
        questionText: question.questionText || '',
        questionType: question.questionType || 'singleChoice',
        correctAnswerText: question.correctAnswerText || '',
        isActive: question.isActive || 'Y',
        options: []
      };
      hydrated.options = (question.options || []).map((option, optionIndex) => this.hydrateOption(option, optionIndex));
      this.handleQuestionTypeChange(hydrated, true);
      return hydrated;
    },
    hydrateOption(option, index) {
      return {
        id: option.id || null,
        localKey: option.id || `option-${Date.now()}-${index}`,
        optionText: option.optionText || '',
        isCorrect: option.isCorrect || 'N',
        isCorrectBool: option.isCorrect === 'Y'
      };
    },
    createQuestion() {
      const timestamp = Date.now();
      return {
        id: null,
        localKey: `question-${timestamp}-${this.form.questions.length}`,
        questionText: '',
        questionType: 'singleChoice',
        correctAnswerText: '',
        isActive: 'Y',
        options: [
          this.createOption('', 'Y', 0),
          this.createOption('', 'N', 1)
        ]
      };
    },
    createOption(text, isCorrect, index) {
      return {
        id: null,
        localKey: `option-${Date.now()}-${index}`,
        optionText: text,
        isCorrect,
        isCorrectBool: isCorrect === 'Y'
      };
    },
    addQuestion() {
      this.form.questions.push(this.createQuestion());
    },
    removeQuestion(index) {
      this.form.questions.splice(index, 1);
      if (this.form.questions.length === 0) {
        this.addQuestion();
      }
    },
    isTextQuestion(question) {
      return ['singleLineText', 'multiLineText'].includes(question.questionType);
    },
    handleQuestionTypeChange(question, keepExistingOptions = false) {
      if (question.questionType === 'trueFalse') {
        const correctOption = (question.options || []).find(option => option.isCorrect === 'Y');
        const correctValue = correctOption ? correctOption.optionText : '是';
        question.options = [
          this.createOption('是', correctValue === '是' ? 'Y' : 'N', 0),
          this.createOption('非', correctValue === '非' ? 'Y' : 'N', 1)
        ];
        return;
      }

      if (this.isTextQuestion(question)) {
        question.options = [];
        return;
      }

      if (!keepExistingOptions || !question.options || question.options.length === 0) {
        question.options = [
          this.createOption('', 'Y', 0),
          this.createOption('', 'N', 1)
        ];
      }

      if (question.questionType === 'singleChoice') {
        if (!question.options.some(option => option.isCorrect === 'Y')) {
          question.options[0].isCorrect = 'Y';
          question.options[0].isCorrectBool = true;
        }
        question.options.forEach((option, index) => {
          if (index > 0 && option.isCorrect === 'Y') {
            option.isCorrect = 'N';
            option.isCorrectBool = false;
          }
        });
      }
    },
    setSingleCorrect(question, optionIndex) {
      question.options.forEach((option, index) => {
        option.isCorrect = index === optionIndex ? 'Y' : 'N';
        option.isCorrectBool = index === optionIndex;
      });
    },
    setMultipleCorrect(option) {
      option.isCorrect = option.isCorrectBool ? 'Y' : 'N';
    },
    addOption(question) {
      question.options.push(this.createOption('', 'N', question.options.length));
    },
    removeOption(question, optionIndex) {
      question.options.splice(optionIndex, 1);
      if (question.questionType === 'singleChoice' && question.options.length > 0 && !question.options.some(option => option.isCorrect === 'Y')) {
        question.options[0].isCorrect = 'Y';
        question.options[0].isCorrectBool = true;
      }
    },
    validateQuestion(question) {
      if (!question || !question.questionText || !question.questionText.trim()) {
        return '題目內容不可空白';
      }

      if (this.isTextQuestion(question)) {
        if (!question.correctAnswerText || !question.correctAnswerText.trim()) {
          return '文字題必須設定標準答案';
        }
        return '';
      }

      if (!question.options || question.options.length < 2) {
        return '選擇題至少需要兩個選項';
      }

      if (question.options.some(option => !option.optionText || !option.optionText.trim())) {
        return '題目選項不可空白';
      }

      const correctOptionCount = question.options.filter(option => option.isCorrect === 'Y').length;
      if (question.questionType === 'trueFalse' && (question.options.length !== 2 || correctOptionCount !== 1)) {
        return '是非題必須有兩個選項且只能設定一個正確答案';
      }

      if (question.questionType === 'singleChoice' && correctOptionCount !== 1) {
        return '單選題必須設定一個正確答案';
      }

      if (question.questionType === 'multipleChoice' && correctOptionCount === 0) {
        return '多選題至少需要一個正確答案';
      }

      return '';
    },
    validateForm() {
      if (!this.form.title || !this.form.title.trim()) {
        return '請輸入模組標題';
      }

      if (!this.form.videoUrl || !this.form.videoUrl.trim()) {
        return '請輸入影片連結';
      }

      const activeQuestions = this.form.questions.filter(question => question.isActive === 'Y');
      if (activeQuestions.length === 0) {
        return '至少需要一題啟用中的題目';
      }

      for (const question of activeQuestions) {
        const validationMessage = this.validateQuestion(question);
        if (validationMessage) {
          return validationMessage;
        }
      }

      if (activeQuestions.length < 2) {
        return '至少需要兩題啟用中的題目';
      }

      if (this.form.drawQuestionCount <= 0) {
        return '抽題數必須大於 0';
      }

      if (this.form.drawQuestionCount >= activeQuestions.length) {
        return '抽題數必須小於啟用中的題目數';
      }

      if (this.form.passQuestionCount <= 0) {
        return '及格題數必須大於 0';
      }

      if (this.form.passQuestionCount > this.form.drawQuestionCount) {
        return '及格題數不可大於抽題數';
      }

      return '';
    },
    buildPayload() {
      return {
        id: this.form.id,
        title: this.form.title,
        description: this.form.description,
        videoUrl: this.form.videoUrl,
        drawQuestionCount: this.form.drawQuestionCount,
        passQuestionCount: this.form.passQuestionCount,
        isPublished: this.form.isPublished,
        questions: this.form.questions.map((question, questionIndex) => {
          const payloadQuestion = {
            id: question.id,
            questionText: question.questionText,
            questionType: question.questionType,
            correctAnswerText: this.isTextQuestion(question) ? question.correctAnswerText : '',
            displaySort: questionIndex + 1,
            isActive: question.isActive,
            options: []
          };
          if (!this.isTextQuestion(question)) {
            payloadQuestion.options = question.options.map((option, optionIndex) => ({
              id: option.id,
              optionText: option.optionText,
              isCorrect: option.isCorrect,
              displaySort: optionIndex + 1
            }));
          }
          return payloadQuestion;
        })
      };
    },
    saveModule() {
      const validationMessage = this.validateForm();
      if (validationMessage) {
        bootbox.alert(validationMessage);
        return;
      }

      const payload = this.buildPayload();
      this.$axios.post('/api/DormitoryTraining/module', payload).then(resp => {
        if (resp.data.status === 'success') {
          bootbox.alert(resp.data.msg || '儲存成功', () => {
            this.$router.push({ name: 'stay.training' });
          });
        } else {
          bootbox.alert(resp.data.msg || '儲存失敗');
        }
      });
    }
  }
};
</script>

<style scoped>
.question-card {
  margin-bottom: 16px;
}

.option-row {
  margin-bottom: 8px;
}

.option-check {
  padding-top: 7px;
}

.true-false-editor {
  padding-top: 6px;
}
</style>